export const CREDENTIAL_TYPE = [
  { name: "License", id: 1 },
  { name: "Certificate", id: 2 },
  { name: "Training", id: 3 },
];

export const CREDENTIAL_NAME_MAX_LENGTH = 100;

export const CREDENTIAL_NAME_SORT = {
  NAME: "name",
  TYPE: "type",
};

const TYPE_TRANSLATION_KEY = {
  1: "accountOwner.license",
  2: "accountOwner.certification",
  3: "accountOwner.training",
};

/**
 * @param {number|string} typeId
 * @param {(key: string) => string} t
 * @returns {string}
 */
export function getCredentialTypeLabel(typeId, t) {
  const key = TYPE_TRANSLATION_KEY[+typeId];
  return key ? t(key) : "";
}

/**
 * @param {(key: string) => string} t
 * @returns {{ id: number, name: string }[]}
 */
export function getCredentialTypeOptions(t) {
  return CREDENTIAL_TYPE.map((type) => ({
    ...type,
    name: getCredentialTypeLabel(type.id, t) || type.name,
  }));
}
